<template>
  <div>
        <div class="-mx-2 lg:flex">
            <div class="w-full lg:w-1/3 px-2">
                <div class="rounded-lg shadow-sm mb-4">
                    <div class="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                        <div class="absolute top-0 left-0" style="top: -10%;left: -10%;">
                            <fa icon="user-tie" class="mr-2 text-blue-50" style="width: 12rem;height: 12rem;" />
                        </div>
                        <div class="px-3 pt-8 pb-10 text-center relative z-10">
                            <h4 class="text-sm uppercase text-gray-500 leading-tight">Nowe Umowy/Klienci</h4>
                            <h3 class="text-3xl text-gray-700 font-semibold leading-tight my-3">{{ clients.today }}</h3>
                            <p class="text-xs leading-tight" :class="colorClasses(clients)">
                                <fa :icon="iconType(clients)" :class="colorClasses(clients)" fixed-width />
                                {{ clientsPercentage }}%
                            </p>
                        </div>
                        <div class="absolute bottom-0 inset-x-0">

                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/3 px-2">
                <div class="rounded-lg shadow-sm mb-4">
                    <div class="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                        <div class="absolute top-0 left-0" style="top: -10%;left: -10%;">
                            <fa icon="file-invoice" class="mr-2 text-orange-50" style="width: 12rem;height: 12rem;" />
                        </div>
                        <div class="px-3 pt-8 pb-10 text-center relative z-10">
                            <h4 class="text-sm uppercase text-gray-500 leading-tight">Wartość faktur</h4>
                            <h3 class="text-3xl text-gray-700 font-semibold leading-tight my-3">{{ (factures.today * 1.00).toFixed(2).replace('.', ',') }} <small class="text-gray-500">PLN</small></h3>
                            <p class="text-xs leading-tight" :class="colorClasses(factures)">
                                <fa :icon="iconType(factures)" :class="colorClasses(factures)" fixed-width />
                                {{ facturesPercentage }}%
                            </p>
                        </div>
                        <div class="absolute bottom-2 inset-x-0 right-4 uppercase text-right text-gray-500 text-xs z-10">
                            <inertia-link :href="route('stats.factures')">więcej</inertia-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/3 px-2">
                <div class="rounded-lg shadow-sm mb-4">
                    <div class="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                        <div class="absolute top-0 left-0" style="top: -10%;left: -10%;">
                            <fa icon="file-export" class="mr-2 text-red-50" style="width: 12rem;height: 12rem;" />
                        </div>
                        <div class="px-3 pt-8 pb-10 text-center relative z-10">
                            <h4 class="text-sm uppercase text-gray-500 leading-tight">Wypowiedziane umowy</h4>
                            <h3 class="text-3xl text-gray-700 font-semibold leading-tight my-3">{{ contracts.today }}</h3>
                            <p class="text-xs leading-tight" :class="colorClasses(contracts)">
                                <fa :icon="iconType(contracts)" :class="colorClasses(contracts)" fixed-width />
                                {{ contractsPercentage }}%
                            </p>
                        </div>
                        <div class="absolute bottom-0 inset-x-0">

                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Strona główna' },
  layout: Layout,
  props: {
    clients: Object,
    contracts: Object,
    factures: Object
  },
  computed: {
    facturesPercentage() {
        // console.log(this.factures.today +'/'+ this.factures.yesterday +'='+ (this.factures.today/this.factures.yesterday))
        return Math.abs((1.0 - (this.factures.today/this.factures.yesterday)) * 100.00).toFixed(2).replace('.', ',')
    },
    contractsPercentage() {
        if (this.contracts.today > this.contracts.yesterday)
            return Math.abs(((1.0 - (this.contracts.yesterday/this.contracts.today)) * 100.00)).toFixed(2).replace('.', ',')    
        return Math.abs((1.0 - (this.contracts.today/this.contracts.yesterday)) * 100.00).toFixed(2).replace('.', ',')
    },
    clientsPercentage() {
        return Math.abs((1.0 - (this.clients.today/this.clients.yesterday)) * 100.00).toFixed(2).replace('.', ',')
    }
  },
  methods: {
    colorClasses(data) {
        if (data.today < data.yesterday)
            return 'text-red-500'

        if (data.today > data.yesterday)
            return 'text-green-500'

        return 'text-gray-400'
    },
    iconType(data) {
        if (data.today < data.yesterday)
            return 'long-arrow-alt-down'

        if (data.today > data.yesterday)
            return 'long-arrow-alt-up'

        return 'arrows-alt-h'
    }
  }
}
</script>
